import { CardIllustration, Label, Size } from '@easylife365/react';
import type { LogoLabelProps } from './types';
import './LogoLabel.css';

const LogoLabel: React.FC<LogoLabelProps> = ({ hideLogo, imageUrl, subTitleSize, subtitle, title }) => {
  if (!title) return null;

  return (
    <div className="logo-label">
      {hideLogo !== true &&
        (imageUrl ? (
          <CardIllustration source={imageUrl} size={Size.Small} />
        ) : (
          <CardIllustration size={Size.Small} title={title} />
        ))}
      <div className="labels-container">
        <Label label={title} />
        <Label label={subtitle} size={subTitleSize ?? Size.Small} />
      </div>
    </div>
  );
};

export default LogoLabel;
